import React from 'react'
import { Header2, Header3, Text } from '../../styles/Components'
import { gsColors as c } from '../../styles/Variables'
import Button from '../Button'
import Image from 'next/image'
import PrepImage from '../../../public/how-it-works/GS_how_it_works_prep.jpg'

const Prepping = () => {
  return (
    <div className="section-wrapper prepping">
      <div className="content">
        <div className="inner">
          <Header2 color={c.salmon} margin="0 0 12px 0">
            Prepping is easy
          </Header2>
          <Header3 color={c.salmon} margin="0 0 64px 0" fontSize={24}>
            All we need is a flat surface with an outlet nearby to set up our
            products and tools.
          </Header3>
          <Text
            variant="medium"
            weight={700}
            color={c.salmon}
            margin="0 0 6px 0"
          >
            Hair
          </Text>
          <Text variant="small" lineHeight="145%" color={c.salmon}>
            For blowouts, make sure you have damp hair (we recommend washing
            about 10-15 min beforehand). For dry styling and updos, second-day
            hair is best.
          </Text>
          <div className="divider" />
          <Text
            variant="medium"
            weight={700}
            color={c.salmon}
            margin="0 0 6px 0"
          >
            Makeup
          </Text>
          <Text variant="small" lineHeight="145%" color={c.salmon}>
            For best results, we suggest cleansing and moisturizing your skin
            before we arrive.
          </Text>
          <div className="divider" />
          <Text
            variant="medium"
            weight={700}
            color={c.salmon}
            margin="0 0 6px 0"
          >
            Nails
          </Text>
          <Text variant="small" lineHeight="145%" color={c.salmon}>
            Please be sure your nails are free of any hard gels or acrylics (we
            are unable to remove them at this time). We can remove shellac or
            soakable gels for a $10 fee.
          </Text>
          <Button
            color={c.salmon}
            path="book"
            large
            outline
            margin="64px 0 0 0"
          >
            Book Now
          </Button>
        </div>
      </div>
      <div className="image-placeholder">
        <Image
          src={PrepImage}
          style={{ objectFit: 'cover' }}
          fill
          alt='how to prep'
          priority
        />
      </div>
    </div>
  )
}

export default Prepping
